import React, { ReactNode, useEffect, useRef, useState } from 'react'
import { styled } from 'styled-components';
import LabelNumber from '../../../styled-components/LabelNumber';
import CustomDropdown from '../../../ui/CustomDropdown';
import LabelText from '../../../ui/LabelText';
import { IOption } from '../../../types/IOption';
import { useTheme } from '../../../contexts/ThemeContext';
import { Icontrubution, ISeasonBuildUpPlay, ISeasonData, ISeasonDefence, IseasonFeaturesData, ISeasonFinalThird, ISeasonPhysical, ItransferMarketValue, ItransferValueBenchmark, IValueSeasonGraphChart } from '../../../types/IValueGraphChart';
import * as d3 from 'd3';
import { ModuleSpinner } from '../../../ui/LoadingSpinner/ModuleSpinner';
import { create, flatMap } from 'lodash';
import { IseasonData } from '../../../types/IClubDetail';
import SecondaryButton from '../../../ui/SecondaryButton';
import CloseIcon from "@mui/icons-material/Close";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import PWNotification from '../../PWNotification';
import PinchIcon from "../../../assets/icons/pinchIcon.svg";
import Switch from '../../../ui/CustomSwitch';
import noDataBackground from "../../../assets/images/NoDataBackground.png"
import { data } from 'jquery';


const YAxisContainer = styled.div`
  position: sticky;
  left: 0;
  z-index: 0;
  width: 200px;
  box-shadow: 10px -1px 10px -5px rgba(0, 0, 0, 0.25)
`;
const SvgStyled = styled.svg`
  border-top: 1px solid ${({ theme }) => theme.playerDataBorder};
`;

const BottomSideBar = styled.div`
  // border-right :3px solid ${({ theme }) => theme.playerDataBorder}
`;

const BottomLeftContainer = styled.div`
  border-bottom :2px solid ${({ theme }) => theme.playerDataBorder}
`;
const SubAttributes = styled.div`
    border: 1px solid ${({ theme }) => theme.playerDataBorder};
    background: ${({ theme }) => theme.expanderColor};
`;
const Exapanders = styled.div`
    border: 1px solid ${({ theme }) => theme.playerDataBorder};
    background: ${({ theme }) => theme.expanderColor};
    color : ${({ theme }) => theme.playerColor}
`;
interface SvgElementConfig {
    ref: React.MutableRefObject<SVGSVGElement | null>;
    width: number;
    height: number;
}
const Options: IOption[] = [
    { value: 'Football', label: 'Football' },
    // { value: 'Financial', label: 'Financial' },
    // { value: 'Market', label: 'Market' },
    // { value: 'Commercial', label: 'Commercial' },
    { value: 'Attribute-score', label: 'Attribute score' },
];

interface SelectedAttribute {
    isFinalThird: boolean;
    isBuildUpPlay: boolean;
    isDefence: boolean;
    isPhysical: boolean;
}

interface Attribute {
    color: string;
    text: string;
}

interface SvgElementConfig {
    ref: React.MutableRefObject<SVGSVGElement | null>;
    width: number;
    height: number;
}

interface Point {
    x: number;
    y: number;
    value: number;
    color: string;
}

interface LineEnd {
    data: Point;
}

type Category = 'finalThird' | 'buildUpPlay' | 'defence' | 'physical';

const attributeData: { [key in keyof SelectedAttribute]: Attribute[] } = {
    isFinalThird: [
        { color: '#FF3864', text: 'finishing shots' },
        { color: '#00A1E4', text: 'finishing aerial' },
        { color: '#F2E94E', text: 'attack positioning' }
    ],
    isBuildUpPlay: [
        { color: '#FF3864', text: 'creativity' },
        { color: '#00A1E4', text: 'crossing' },
        { color: '#F2E94E', text: 'dribbling' },
        { color: '#4AF075', text: 'passing accuracy' }
    ],
    isDefence: [
        { color: '#FF3864', text: 'Ball Recovery' },//aggression
        { color: '#00A1E4', text: 'defensive Headers' },
        { color: '#F2E94E', text: 'tackling' }
    ],
    isPhysical: [
        { color: '#FF3864', text: 'speed' },
        { color: '#00A1E4', text: 'strength' },
        { color: '#F2E94E', text: 'work rate' }
    ]
};

const AttributeItem: React.FC<{ color: string; text: string }> = ({ color, text }) => (
    <div className='detail-attributes-container'>
        <span className='attributes-marker' style={{ backgroundColor: color }}></span>
        <LabelNumber className='position-text attribute-text'>{text}</LabelNumber>
    </div>
);

const attributes = [
    { key: 'isFinalThird', label: 'FINAL THIRD', color: '#00D1A8' },
    { key: 'isBuildUpPlay', label: 'BUILD UP PLAY', color: '#FF7800' },
    { key: 'isDefence', label: 'DEFENCE', color: '#C9F0B5' },
    { key: 'isPhysical', label: 'PHYSICAL', color: '#FFC2C2' },
];

const renderSelectedAttributeDetails = (selectedAttribute: SelectedAttribute) => {
    for (const [key, attributes] of Object.entries(attributeData) as [keyof SelectedAttribute, Attribute[]][]) {
        if (selectedAttribute[key]) {
            return (
                <SubAttributes className='detail-attributes'>
                    {attributes.map((attr, index) => (
                        <AttributeItem key={index} color={attr.color} text={attr.text} />
                    ))}
                </SubAttributes>
            );
        }
    }
    return null;
};


interface IValueSeasonGraphProps {
    transferValueSeasonData: IValueSeasonGraphChart | undefined;
    isFullView: boolean;
    isLoading: boolean;
}
const ValueGraphChartForSeasons: React.FC<IValueSeasonGraphProps> = ({ transferValueSeasonData, isFullView, isLoading }) => {

    const SeasonValuationYAxisRef = useRef<SVGSVGElement>(null);
    const SeasonValuationSVGRef = useRef<SVGSVGElement>(null);
    const SeasonSVGRef = useRef<SVGSVGElement | null>(null);
    const DaysInjuredSVGRef = useRef<SVGSVGElement | null>(null);
    const MinsPlayedSVGRef = useRef<SVGSVGElement | null>(null);
    const GoalsSVGRef = useRef<SVGSVGElement | null>(null);
    const AssitsSVGRef = useRef<SVGSVGElement | null>(null);
    const AVGoalsSVGRef = useRef<SVGSVGElement | null>(null);
    const AVAssitsSVGRef = useRef<SVGSVGElement | null>(null);
    const AttributesYAxisSVGRef = useRef<SVGSVGElement | null>(null);
    const attributionSVG = useRef<SVGSVGElement | null>(null);//attributionSVG
    const CompetetionChartRef = useRef<HTMLDivElement | null>(null);
    const CompetitionSVGRef = useRef<SVGSVGElement | null>(null);
    const ContributionSVGRef = useRef<SVGSVGElement | null>(null);

    const { theme } = useTheme();

    const margin = { top: 40, right: 0, bottom: 0, left: 0 };
    const dataLength = transferValueSeasonData?.driver.length!
    // const barWidth = dataLength >14 ? 70 : dataLength <= 4 ? 260 : 174;
    // const barWidth = dataLength >14 ? 70 : 260;
    const calculatedBarWidth = (isFullView ? 1574 : 1095) / dataLength;
    const barWidth = calculatedBarWidth < 260 && calculatedBarWidth > 50 ? calculatedBarWidth : calculatedBarWidth > 260 ? 260 : 50 
    const totalGraphWidth = barWidth * dataLength
    // const totalGraphWidth = Math.max(isFullView ? 1570 : 810, barWidth * (transferValueSeasonData?.driver?.length!));
    const [attributeGraphHeight,setAttributeGraphHeight] = useState<number>(414);
    const attributionGraphBaseHeight = 414;
    const [dimensions, setDimensions] = useState({ width: 0, height: 0 });
    const [selectedGraph, setSelectedGraph] = useState<string>('Football');
    const [selectedAttribute, setSelectedAttribute] = useState({
        isFinalThird: false,
        isBuildUpPlay: false,
        isDefence: false,
        isPhysical: false,
    });
    const [hasNoAttributes, sethasNoAttributes] = useState<boolean>(false)
    const [hasfinalthirdNoAttributes, sethasfinalthirdNoAttributes] = useState<boolean>(false)
    const [hasbuildupNoAttributes, sethasbuildupNoAttributes] = useState<boolean>(false)
    const [hasdefenceNoAttributes, sethasdefenceNoAttributes] = useState<boolean>(false)
    // const [valuationInfo , setValuationInfo] = useState<any>(null)
    // const [valuationInfoseason , setValuationInfoSeason] = useState<any>(null)
    const [seasonValuationInfo, setSeasonValuationInfo] = useState<{
        transferMarketValue: ItransferMarketValue;
        seasonStartDate: string;
        seasonEndDate: string;
    } | null>(null);

    const [seasonAtrributesInfo, setSeasonAttributesInfo] = useState<{
        finalThird: ISeasonFinalThird;
        buildUpPlay: ISeasonBuildUpPlay;
        defence: ISeasonDefence;
        physical: ISeasonPhysical;
        seasonStartDate: string;
        seasonEndDate: string;
    } | null>(null);

    const [seasonContrinutionInfo, setSeasonContributionInfo] = useState<{
        contribution: Icontrubution;
        seasonStartDate: string;
        seasonEndDate: string;
    } | null>(null);

    const [selectedInfoAttribute, setSelectedInfoAttribute] = useState({
        isFinalThird: false,
        isBuildUpPlay: false,
        isDefence: false,
        isPhysical: false,
    })

    const [displayCustomNotification, setDisplayCustomNotification] = useState<boolean>(false);
    const [customNotificationContent, setCustomNotificationContent] = useState<ReactNode>(null)
    const [currentScale, setCurrentScale] = useState(1); // Track zoom level
    const [isLeague, setIsLeague] = useState<boolean>(false);


    // const [competitionsData, setCompetitionsData] = useState<any[]>([]);
    const seasonData = transferValueSeasonData?.driver.flatMap(season => season.seasonTeamsData) || [];
    const transferMarketValue = transferValueSeasonData?.driver.flatMap(season => season.seasonTeamsData.map(team => team.transferMarketValue)) || [];
    const transferValueBenchmark = transferValueSeasonData?.driver.flatMap(season => season.seasonTeamsData.map(team => team.transferValueBenchmark)) || []
    // const attributeGraphHeight = 414;
    const padding = 40;
    const bottomPadding = 12;
    const AttributionSvg = useRef<d3.Selection<SVGSVGElement, unknown, null, undefined> | null>(null);
    const AttributesGroup = useRef<d3.Selection<SVGGElement, unknown, null, undefined> | null>(null);
    const updateAttributeYAxis = useRef<(scale: d3.ScaleLinear<number, number>) => void>();

    const xScale = d3.scaleBand<string>()
        .domain((transferValueSeasonData?.driver || []).map(d => d.seasonName)) // Ensure it's an array
        .range([0, totalGraphWidth]);

    const rectWidth = xScale.bandwidth();

    const xData = transferValueSeasonData?.driver.flatMap(d => 
        d.seasonTeamsData.map((t, index) => 
            xScale(d.seasonName)! + ((index + 1) / (d.seasonTeamsData.length + 1)) * rectWidth
        )
    ) || [];


    const tooltip = d3.select("body").append("div")
        .style("position", "fixed")
        .style("z-index", 999)
        .style("visibility", "hidden")
        .style("background-color", theme.secondaryButtonBackground)
        .style("color", theme.color)
        .style("border", "1px solid ${theme.secondaryButtonBackground}")
        .style("padding", "8px")
        .style("border-radius", "4px")
        .style("box-shadow", "0px 0px 6px rgba(0, 0, 0, 0.1)")

    let pathClass: string;
    let lineGenerator: any;

    useEffect(() => {
        if (selectedGraph === 'Attribute-score') { setDisplayCustomNotification(true) }
    }, [selectedGraph])

    useEffect(() => {
        setCustomNotificationContent(
            <div className="notification">
                <p className="sortlist-notofication-content">
                    <img src={PinchIcon} width={24} height={24} />
                    <LabelText className="squad-chart-tooltip notification-content">Scroll up/down to zoom
                    </LabelText>
                    <LabelText
                        className="player-given-name notification-content"
                    >
                        - Don’t show again
                    </LabelText>
                </p>
            </div>
        );
    }, [displayCustomNotification]);


    const createScale = (min: number, max: number) => {
        if (min === max) {
            min -= 1;
            max += 1;
        }
        return d3.scaleLinear()
            .domain([min, max])
            .range([attributeGraphHeight - bottomPadding, padding])
            .nice();
    };

    const setSvgAttributes = (svg: d3.Selection<SVGSVGElement, unknown, null, undefined>, width: number, height: number) => {
        svg.attr('width', width).attr('height', height).selectAll("*").remove();
    };

    const createGroup = (svg: d3.Selection<SVGSVGElement, unknown, null, undefined>, margin: { top: number; left: number }) => {
        return svg.append('g')//.attr('transform', `translate(${margin.left},${margin.top})`);
    }

    const drawYAxis = (
        yAxisDivisions: { value: number; text: string }[],
        yMainFGroup: d3.Selection<SVGSVGElement, unknown, null, undefined>,
        yAxisLineGroup: d3.Selection<SVGGElement, unknown, null, undefined>,
        totalWidth: number,
        yScale: d3.ScaleLinear<number, number, never>,
        height: number,
        margin: { top: number; right: number; bottom: number; left: number; }
    ) => {

        const yAxisText = yMainFGroup
            .selectAll(".y-axis-text")
            .data(yAxisDivisions, (d: any) => d.value) // Use `value` as a unique key
            .join(
                (enter) =>
                    enter
                        .append("text")
                        .attr("class", "y-axis-text")
                        .attr("x", 160)
                        .attr("y", (d) => yScale(d.value) - 8)
                        .style("text-anchor", "end")
                        .style("font-size", "20px")
                        .style("font-weight", "500")
                        .style("font-family", "DM Mono")
                        .style("fill", theme.playerColor)
                        .text((d) => d.text || ""),
                (update) =>
                    update.style("fill", theme.playerColor) // Update style if necessary
            );

        const yGridLines = yAxisLineGroup
            .selectAll(".y-grid-line")
            .data(yAxisDivisions, (d: any) => d.value) // Use `value` as a unique key
            .join(
                (enter) =>
                    enter
                        .append("line")
                        .attr("class", "y-grid-line")
                        .attr("x1", -180)
                        .attr("y1", (d) => yScale(d.value))
                        .attr("x2", totalWidth)
                        .attr("y2", (d) => yScale(d.value))
                        .style("stroke", theme.playerDataBorder)
                        .style("stroke-width", 1),
                (update) =>
                    update // Update positions dynamically
                        .attr("x1", -180)
                        .attr("x2", totalWidth)
            );

        // yAxisLineGroup
        //     .selectAll(".y-axis-shadow")
        //     .data([0]) // Single datum for the shadow line
        //     .join("line")
        //     .attr("class", "y-axis-shadow")
        //     .attr("x1", 198)
        //     .attr("y1", 0)
        //     .attr("x2", 198)
        //     .attr("y2", height + margin.top - margin.bottom)
        //     .style("stroke", theme.playerDataBorder)
        //     .style("stroke-width", 3);

        const updateYAxis = (newYScale: d3.ScaleLinear<number, number, never>) => {
            yAxisText
                .transition()
                .duration(500)
                .attr("y", (d) => newYScale(d.value) - 15);
            yGridLines
                .transition()
                .duration(500)
                .attr("y1", (d) => newYScale(d.value))
                .attr("y2", (d) => newYScale(d.value));
        };

        return updateYAxis;

    };

    const drawLinePath = (
        group: d3.Selection<SVGGElement, unknown, null, undefined>,
        data: any[],
        xAccessor: (d: any) => number,
        yAccessor: (d: any) => number,
        lineColor: string,
        lineGenerator: any,
        strokeWidth = 4
    ): d3.Selection<SVGPathElement, any[], null, undefined> => {
        const line = d3.line<any>()
            .x(xAccessor)
            .y(yAccessor)
            .curve(d3.curveMonotoneX);

        return group.append("path")
            .datum(data)
            .attr("fill", "none")
            .attr("stroke", lineColor)
            .attr("stroke-width", strokeWidth)
            .attr("d", lineGenerator);
    };

    const drawSeasonRect = (
        group: d3.Selection<SVGGElement, unknown, null, undefined>,
        data: any[],
        xScale: d3.ScaleBand<string>,
        rectWidth: number,
        height: number,
        colors: string[],
        onClick?: (event: MouseEvent, d: any) => void
    ) => {
        const rects = group.selectAll(".season-rect")
            .data(data)
            .enter()
            .append("rect")
            .attr("class", "season-rect")
            .attr("x", d => xScale(d.seasonName)!)
            .attr("y", 0)
            .attr("width", rectWidth)
            .attr("height", height - 2)
            .attr("fill", (d, i) => colors[i % 2]);
    
        if (onClick) {
            rects.on("click", onClick);
            rects.style("cursor", "pointer")
        }
    };

    const drawHorizontalLines = (
        group: d3.Selection<SVGGElement, unknown, null, undefined>,
        data: number[],
        x1Fn: (d: number) => number, // Function to compute x1
        x2Fn: (d: number) => number, // Function to compute x2
        y1Fn: (d: number) => number, // Function to compute y1
        y2Fn: (d: number) => number, // Function to compute y2
        lineClass: string = "horizontal-line", // CSS class for the lines
        strokeColor: string = "#ccc", // Default stroke color
        strokeWidth: number = 1 // Default stroke width
    ): void => {
        group
            .selectAll(`.${lineClass}`) // Select existing lines by class
            .data(data) // Bind data to the lines
            .join(
                (enter) =>
                    enter
                        .append("line")
                        .attr("class", lineClass) // Apply the class
                        .attr("x1", x1Fn) // Use the x1 function
                        .attr("x2", x2Fn) // Use the x2 function
                        .attr("y1", y1Fn) // Use the y1 function
                        .attr("y2", y2Fn) // Use the y2 function
                        .attr("stroke", strokeColor)
                        .attr("stroke-width", strokeWidth),
                (update) =>
                    update
                        .attr("x1", x1Fn) // Update x1
                        .attr("x2", x2Fn) // Update x2
                        .attr("y1", y1Fn) // Update y1
                        .attr("y2", y2Fn) // Update y2
                        .attr("stroke", strokeColor)
                        .attr("stroke-width", strokeWidth),
                (exit) => exit.remove() // Remove any lines that are no longer in data
            );
    };

    const renderSeasonData = (
        Seasondata: ISeasonData[],
        SeasonGroup: d3.Selection<SVGGElement, unknown, null, undefined>,
        xScale: d3.ScaleBand<string>,
        yScale: d3.ScaleLinear<number, number>,
        theme: any
    ) => {
        const seenSeasons = new Set(); // Track seen season names
        const seasonPositionMap = new Map(); // Track last text position for each seasonName

        const matchSelection = SeasonGroup
            .selectAll("g.match")
            .data(Seasondata.flat()); // Flatten match data array if necessary

        matchSelection
            .join(
                (enter) => enter
                    .append("g")
                    .attr("class", "match")
                    .each(function (d: any, i) {
                        const currentX = xData ? xData[i] : 0 ;

                        if (!seenSeasons.has(d.seasonName)) {
                            seenSeasons.add(d.seasonName); // Mark as seen
                            seasonPositionMap.set(d.seasonName, currentX); // Store its position

                            // Render Season Name Text
                            d3.select(this)
                                .append("text")
                                .attr("x", currentX + (d.seasonName.includes('/') ? 25 : 9))
                                .attr("y", 20)
                                .style("font-size", "10px")
                                .style("font-family", "DM Mono")
                                .style("font-style", "normal")
                                .style("font-weight", 500)
                                .style("fill", theme.playerColor)
                                .text(d.seasonName);
                        } else {
                            // Adjust previous season text position if duplicate
                            const prevTextX = seasonPositionMap.get(d.seasonName);
                            if (prevTextX !== undefined) {
                                seasonPositionMap.set(d.seasonName, (prevTextX + currentX) / 2); // Adjust position

                                // Update previous text's position
                                SeasonGroup.selectAll("text")
                                    .filter(function () {
                                        return d3.select(this).text() === d.seasonName;
                                    })
                                    .attr("x", (prevTextX + currentX + 50) / 2); // Move to new position
                            }
                        }

                         d3.select(this)
                            .append("image")
                            .attr("class", "match-image")
                            .attr("x",  xData ? xData[i] - 13 : 0)
                            .attr("y", 30)
                            .attr("width", 24)
                            .attr("height", 24)
                            .attr("xlink:href", d.teamLogoURL && d.teamLogoURL)
                            .style("cursor", "pointer")
                            .on("mouseover", (event, d: any) => {
                                tooltip.style("visibility", "visible").html(d.teamName);
                            })
                            .on("mousemove", (event) => {
                                tooltip
                                    .style('left', `${event.clientX - 10}px`)
                                    .style('top', `${event.clientY + 20}px`);
                            })
                            .on("mouseout", () => {
                                tooltip.style("visibility", "hidden");
                            });
                    }),
                (update) => update,
                (exit) => exit.remove()
            );
    };

    const renderBottomGraphText = (
            selection: d3.Selection<SVGGElement, unknown, null, undefined>, 
            data: any[], 
            xScale: d3.ScaleBand<string>,  
            textFn: (d: IseasonFeaturesData) => string ,// Accept a function to determine text
            isDecimal?: boolean
        ) => {
            selection
                .selectAll<SVGTextElement, IseasonFeaturesData>("text")
                .data(data)
                .join("text")
                .attr("x", (d, i) => {
                    const baseX = xData ? xData[i] : 0;  // Get pre-calculated x position
                    return baseX; // Center text in the rect
                })
                .attr("text-anchor", "middle") // Ensures text aligns at the center
                
                // .attr("x",(d,i)=>{ return xData ?? xData[i]/2})
                // .attr("x", (d) => {
                //     const textValue = parseFloat(textFn(d));
                //     const baseX = xScale(d.uniqueKeyId)! + xScale.bandwidth() / 2;
                //     return !isNaN(textValue) && (textValue % 1 !== 0 || (textValue >= 100 && textValue <= 999))  
                //         ? baseX + 15 
                //         : baseX; // Shift if decimal or if it's a three-digit number
                // })
                
                .attr("y", 27)
                .style("font-size", "14px")
                .style("font-family", "DM Mono")
                .style("font-style", "normal")
                .style("font-weight", "500")
                .style("fill", "#7C7D79")
                // .text(d => textFn(d))
                .text(d => {
                    const numValue = parseFloat(textFn(d)); // Convert string to number
                    return isNaN(numValue) ? "" : numValue !== 0  && isDecimal? numValue.toFixed(2) : numValue;
                });
                
    };

    const drawAttributeYAxis = (AttributionYAxisGroup: d3.Selection<SVGGElement, unknown, null, undefined>,
        AttributesGroup: d3.Selection<SVGGElement, unknown, null, undefined>,
        yTicks: number[],
        attributesYScale: d3.ScaleLinear<number, number, never>,
        theme: any,
        totalGraphWidth: number,
        x1Value: number, // New parameter for x1
        x2Value: number,
        xTextValue: number,
        yTextValue: number,
    ) => {
        const attributeYGridLines = AttributionYAxisGroup.selectAll(".attribute-y-axis-line")
            .data(yTicks)
            .enter()
            .append("line")
            .attr('x1', x1Value)
            .attr('x2', x2Value)
            .attr('y1', (d: any) => attributesYScale(d))
            .attr('y2', (d: any) => attributesYScale(d))
            .attr('stroke', theme.playerDataBorder);

        const attributeYAxisText = AttributionYAxisGroup.selectAll(".attribute-y-axis-text")
            .data(yTicks)
            .enter()
            .append("text")
            .attr('x', xTextValue)
            .attr('y', (d: any) => attributesYScale(d) - yTextValue)
            .attr('dy', '0.35em')
            .attr('text-anchor', 'middle')
            .style("fill", theme.playerColor)
            .style("font-family", "DM Mono")
            .style('font-weight', 500)
            .style('font-size', 20)
            .text((d: any) => d);

        const attributeGridLines = AttributesGroup.selectAll(".attribute-line")
            .data(yTicks)
            .enter()
            .append("line")
            .attr('x1', 0)
            .attr('x2', totalGraphWidth)
            .attr('y1', (d: any) => attributesYScale(d))
            .attr('y2', (d: any) => attributesYScale(d))
            .attr('stroke', theme.playerDataBorder);

        const updateAttributeYAxis = (newYScale: d3.ScaleLinear<number, number, never>) => {
            attributeYAxisText
                .transition()
                .duration(500)
                .attr("y", (d) => newYScale(d) - 12);
            attributeYGridLines
                .transition()
                .duration(500)
                .attr("y1", (d) => newYScale(d))
                .attr("y2", (d) => newYScale(d));
            attributeGridLines
                .transition()
                .duration(500)
                .attr("y1", (d) => newYScale(d))
                .attr("y2", (d) => newYScale(d));
        };

        return updateAttributeYAxis;
    }

    const calculateDistance = (point1: Point, point2: Point) => {
        return Math.sqrt(Math.pow(point1.x - point2.x, 2) + Math.pow(point1.y - point2.y, 2));
    };
    let elements = {
        rects: [] as any[],
        circles: [] as any[],
        texts: [] as any[]
    };

    const drawMergedRectangles = (svgGrp: any, endPoints: LineEnd[], threshold: number, yScale?: any) => {
        const mergedGroups: LineEnd[][] = [];
        const usedIndices = new Set<number>();

        // Group points by proximity
        endPoints.forEach((point1, i) => {
            if (usedIndices.has(i)) return;
            const group = [point1];

            endPoints.forEach((point2, j) => {
                if (i !== j && !usedIndices.has(j)) {
                    const distance = calculateDistance(point1.data, point2.data);
                    if (distance <= threshold) {
                        group.push(point2);
                        usedIndices.add(j);
                    }
                }
            });

            mergedGroups.push(group);
            usedIndices.add(i);
        });

        // Draw rectangles and store references
        const elements: { rects: any[]; circles: any[]; texts: any[] } = { rects: [], circles: [], texts: [] };

        mergedGroups.forEach(group => {
            const rectPadding = 5;
            const xMin = Math.min(...group.map(p => p.data.x)) - rectPadding;
            const xMax = Math.max(...group.map(p => p.data.x)) + rectPadding;
            const yMin = Math.min(...group.map(p => p.data.y)) - rectPadding;
            const yMax = Math.max(...group.map(p => p.data.y)) + rectPadding;

            // Draw rectangle
            const rect = svgGrp.append("rect")
                .attr("x", xMin - 10)
                .attr("y", yMin - 5)
                .attr("width", xMax - xMin + 35)
                .attr("height", yMax - yMin + 8)
                .attr("stroke", "none")
                .attr("fill", theme.secondaryButtonBackground)
                .attr("class", "merged-rect")
                .attr('rx',2)
                // .attr('ry',2)
                .attr("stroke", "#DADADA")
                .attr("stroke-width", 1);


            elements.rects.push({ rect, group });

            group.forEach(point => {
                const circle = svgGrp.append("circle")
                    .attr("cx", point.data.x - 9)
                    .attr("cy", point.data.y - 1)
                    .attr("r", 3)
                    .attr("fill", point.data.color)
                    .attr("class", "merged-circle");

                const text = svgGrp.append("text")
                    .attr("x", point.data.x + 10)
                    .attr("y", point.data.y + 2)
                    .attr("text-anchor", "middle")
                    .style("fill", theme.playerColor)
                    .style("font-family", "DM Mono")
                    .style("font-weight", 500)
                    .style("font-size", 10)
                    .text(point.data.value)
                    .attr("class", "merged-text");

                elements.circles.push({ circle, point });
                elements.texts.push({ text, point });

            });
        });

        return elements;
    };

    const renderCompetitionData = (group: d3.Selection<SVGGElement, unknown, null, undefined>, seasonName: string, image: string, countryName: string, competitionName: string, xPosition: number, theme: any) => {

        group.append("image")
            .attr("xlink:href", `/assets/country_flags/${image || ""}.svg`)
            .attr("x", xPosition + 42)
            .attr("y", 18)
            .attr("width", 12)
            .style("cursor", "pointer")
            .attr("height", 12).on("mouseover", (event, d: any) => {
                tooltip.style("visibility", "visible").html(countryName);
            })
            .on("mousemove", (event) => {
                tooltip
                    .style('left', `${event.clientX - 10}px`)
                    .style('top', `${event.clientY + 10}px`);
            })
            .on("mouseout", () => {
                tooltip.style("visibility", "hidden");
            });

        group.append("text")
            .attr("x", xPosition + 38)
            .attr("y", 30)
            .style("font-size", "14px")
            .style("font-family", "DM Mono")
            .style("font-style", "normal")
            .style("text-transform", "uppercase")
            .style("fill", theme.playerColor)
            .style("cursor", "pointer")
            .text(seasonName).on("mouseover", (event, d: any) => {
                tooltip.style("visibility", "visible").html(competitionName);
            })
            .on("mousemove", (event) => {
                tooltip
                    .style('left', `${event.clientX - 10}px`)
                    .style('top', `${event.clientY + 10}px`);
            })
            .on("mouseout", () => {
                tooltip.style("visibility", "hidden");
            });
    };

    const addSeasonSeparator = (
        group: d3.Selection<SVGGElement, unknown, null, undefined>,
        xPosition: number,
        y1: number,
        y2: number,
        theme: any
    ) => {
        group.append("line")
            .attr("x1", xPosition)
            .attr("y1", y1)
            .attr("x2", xPosition)
            .attr("y2", y2)
            .style("stroke", theme.NumberColor)
            .style("stroke-width", 1)
        .style("stroke-dasharray", "5,5"); 
    };

    const renderCompetitions = (
        ComepetionsGroup: d3.Selection<SVGGElement, unknown, null, undefined>, 
        competitionsData: any[][], 
        rectWidth: number,
        theme: any,
    ) => {
            const seasonCount = new Map<string, number>(); 
            competitionsData.forEach((competition: any, index) => {
                competition.teams.forEach((team: any) => {
                    const seasonName = team.seasonName;
                    if (!seasonCount.has(seasonName)) {
                        seasonCount.set(seasonName, 1);
                    } else {
                        seasonCount.set(seasonName, seasonCount.get(seasonName)! + 1);
                    }
                });
    
                const firstTeam = competition.teams[0]; 
                if (!firstTeam) return; // If no teams, skip this iteration
                const seasonName = firstTeam.seasonName;
                let seasonX = xScale(seasonName)!; 
                if (seasonCount.get(seasonName)! > 1) {
                    seasonX += (seasonCount.get(seasonName)! - 1) * rectWidth/2;
                }
                renderCompetitionData(
                    ComepetionsGroup, competition.competitionCode, 
                    competition.competitionCountryAlpha3Code, 
                    competition.competitionCountryName, 
                    competition.competitionName, seasonX, theme
                );
                // Add a separator only if it's not the first competition
                if (index > 0) {
                    addSeasonSeparator(ComepetionsGroup, seasonX, 0, 50, theme);
                }
            });
    };
    
    const createRectangleAndText = (group: d3.Selection<SVGGElement, unknown, null, undefined>, x: number, y: number, width: number, height: number, text: string, fill: string, textColor: string) => {
        // Create the rectangle
        group.append('rect')
            .attr('x', x - 50 / 2)  // Center the rect horizontally
            .attr('y', y - height / 2) // Center the rect vertically
            .attr('width', 50)
            .attr('height', height)
            .attr('fill', fill)
            .attr('rx',2)
            // .attr('ry',2)
            .attr("stroke", "#DADADA")
            .attr("stroke-width", 1);

        // Add the text
        group.append('text')
            .attr('x', x)
            .attr('y', y)
            .attr('dy', '.35em')
            .attr('text-anchor', 'middle')
            .text(text)
            .attr('fill', textColor);
    }

    const handleValueGraphChange = (value: string) => {
        setSelectedGraph(value)
        setAttributeGraphHeight(414);
        setCurrentScale(1)
    };

    const finalThirdData = !isLeague ? transferValueSeasonData?.driver.flatMap(season => season.seasonTeamsData.map(team => team.finalThird)) || []
        : transferValueSeasonData?.driver.flatMap(season => season.seasonTeamsData.map(team => team.finalThirdLeague)) || []

    const buildupPlayData = !isLeague ? transferValueSeasonData?.driver.flatMap(season => season.seasonTeamsData.map(team => team.buildUpPlay)) || []
        : transferValueSeasonData?.driver.flatMap(season => season.seasonTeamsData.map(team => team.buildUpPlayLeague)) || []

    const defenceData = !isLeague ? transferValueSeasonData?.driver.flatMap(season => season.seasonTeamsData.map(team => team.defence)) || []
        : transferValueSeasonData?.driver.flatMap(season => season.seasonTeamsData.map(team => team.defenceLeague)) || []

    const physicalData = !isLeague ? transferValueSeasonData?.driver.flatMap(season => season.seasonTeamsData.map(team => team.physical)) || []
        : transferValueSeasonData?.driver.flatMap(season => season.seasonTeamsData.map(team => team.physicalLeague)) || []


    const contributionData = transferValueSeasonData?.driver.flatMap(season => season.seasonTeamsData.map(team => team.seasonFeaturesData.contributionFormUniversal)) || []

    const contributionYScale = d3.scaleLinear()
        .domain([d3.min(contributionData, (d: any) => d?.lowestValue!) - 5, d3.max(contributionData, d => d?.highestValue!)! + 5])
        .range([121, 0]);


    // Combine all data arrays
    const allData = [
        ...finalThirdData,
        ...buildupPlayData,
        ...defenceData,
        ...physicalData,
    ];

    const allAttributesAreZero = physicalData.every(entry => entry.speed === 0 && entry.strength === 0 && entry.workRate === 0);
    const allDefenceZero = defenceData.every(d => d.aggression === 0 && d.defensiveHeaders === 0 && d.tackling === 0)
    const allBuildUpPlayZero = buildupPlayData.every(d => d.creativity === 0 && d.crossing === 0 && d.dribbling === 0 && d.passingAccuracy === 0)
    const allFinathirdZero = finalThirdData.every(d => d.attackPositioning === 0 && d.finishingAerial === 0 && d.finishingShots === 0)
    const allFinalScoreZero = allData.every(d => d.finalScore === 0)

    const getMinMax = (data: any, properties: any) => {
        const values = data.flatMap((item: any) => properties.map((property: any) => item[property]));
        return {
            min: Math.min(...values),
            max: Math.max(...values)
        };
    };

    // Define the properties for each dataset
    const finalThirdProperties = ['finishingShots', 'finishingAerial', 'attackPositioning'];
    const buildUpPlayProperties = ['creativity', 'crossing', 'dribbling', 'passingAccuracy'];
    const defenceProperties = ['aggression', 'defensiveHeaders', 'tackling'];
    const physicalProperties = ['speed', 'strength', 'workRate'];

    // Get min and max values for each dataset
    const { min: finalThirdminValue, max: FinalThirdmaxValue } = getMinMax(finalThirdData, finalThirdProperties);
    const { min: buildUpPlayminValue, max: buildUpPlaymaxValue } = getMinMax(buildupPlayData, buildUpPlayProperties);
    const { min: defenceminValue, max: defencemaxValue } = getMinMax(defenceData, defenceProperties);
    const { min: physicalminValue, max: physicalmaxValue } = getMinMax(physicalData, physicalProperties);

    // Extract finalScore values
    const finalScores = allData.map(item => item.finalScore);

    // Calculate min and max finalScore
    const minFinalScore = Math.min(...finalScores);
    const maxFinalScore = Math.max(...finalScores);

    const attributesYScale = createScale(minFinalScore, maxFinalScore);
    const finalThirdScale = createScale(finalThirdminValue, FinalThirdmaxValue);
    const buildUpPlayScale = createScale(buildUpPlayminValue, buildUpPlaymaxValue);
    const defenceScale = createScale(defenceminValue, defencemaxValue);
    const physicalScale = createScale(physicalminValue, physicalmaxValue);

    const getAttributeYScale = (selectedAttribute: any) => {
        if (selectedAttribute.isFinalThird) return finalThirdScale;
        if (selectedAttribute.isBuildUpPlay) return buildUpPlayScale;
        if (selectedAttribute.isDefence) return defenceScale;
        if (selectedAttribute.isPhysical) return physicalScale;
        return attributesYScale;
    }


    const getPathData = (path: d3.Selection<d3.BaseType, unknown, null, undefined>, d: any, lineGenerator: any, rescaledAttributeY: d3.ScaleLinear<number, number>) => {
        if (path.classed("finishingShots")) return lineGenerator.finishingShots(d, rescaledAttributeY);
        if (path.classed("finishingAerial")) return lineGenerator.finishingAerial(d, rescaledAttributeY);
        if (path.classed("attackPositioning")) return lineGenerator.attackPositioning(d, rescaledAttributeY);
        if (path.classed("creativity")) return lineGenerator.creativity(d, rescaledAttributeY);
        if (path.classed("crossing")) return lineGenerator.crossing(d, rescaledAttributeY);
        if (path.classed("dribbling")) return lineGenerator.dribbling(d, rescaledAttributeY);
        if (path.classed("passingAccuracy")) return lineGenerator.passingAccuracy(d, rescaledAttributeY);
        if (path.classed("aggression")) return lineGenerator.aggression(d, rescaledAttributeY);
        if (path.classed("defensiveHeaders")) return lineGenerator.defensiveHeaders(d, rescaledAttributeY);
        if (path.classed("tackling")) return lineGenerator.tackling(d, rescaledAttributeY);
        if (path.classed("speed")) return lineGenerator.speed(d, rescaledAttributeY);
        if (path.classed("strength")) return lineGenerator.strength(d, rescaledAttributeY);
        if (path.classed("workRate")) return lineGenerator.workRate(d, rescaledAttributeY);
        return lineGenerator.default(d, rescaledAttributeY);
    }

    const rescalePathData = (pathData: string, rescaledAttributeY: d3.ScaleLinear<number, number>) => {
        return pathData
            .split(' ') // Split path data by spaces
            .map((segment: string) => {
                const values = segment.split(','); // Split each segment (e.g., "x,y") into coordinates
                if (values.length === 2) {
                    // const x = parseFloat(values[0]);
                    const y = parseFloat(values[1]);

                    // Rescale the y-coordinate based on the transformed y-scale
                    values[1] = rescaledAttributeY(y).toString(); // Apply rescaled y
                }
                return values.join(','); // Rejoin the coordinates
            })
            .join(' '); // Join all segments back into one path string
    }


    const attributesLinePath = d3.line<any>()
        .x((d, i) => { return xData ? xData[i] : 0})
        .y(d => attributesYScale(d.finalScore))
        .curve(d3.curveMonotoneX);

    const createLineGenerator: any = (yValue: string, scale: d3.ScaleLinear<number, number>) =>
        d3.line<any>()
        .x((d, i) => {return xData ? xData[i] : 0})
        .y(d => scale(d[yValue]))
        .curve(d3.curveMonotoneX);


    const createLineGeneratorsForCategory = (categoryName: Category, scale: d3.ScaleLinear<number, number>) => {
        const attributeNames = {
            finalThird: ['finishingShots', 'finishingAerial', 'attackPositioning'],
            buildUpPlay: ['creativity', 'crossing', 'dribbling', 'passingAccuracy'],
            defence: ['aggression', 'defensiveHeaders', 'tackling'],
            physical: ['speed', 'strength', 'workRate']
        };

        return attributeNames[categoryName].reduce((acc, attribute) => {
            acc[attribute] = createLineGenerator(attribute, scale);
            return acc;
        }, {} as Record<string, any>);
    };

    const lineGenerators = {
        finalThird: createLineGeneratorsForCategory('finalThird', finalThirdScale),
        buildUpPlay: createLineGeneratorsForCategory('buildUpPlay', buildUpPlayScale),
        defence: createLineGeneratorsForCategory('defence', defenceScale),
        physical: createLineGeneratorsForCategory('physical', physicalScale),
    };

   

    //set grapg height and width scrren wise :
    useEffect(() => {
        const resizeObserver = new ResizeObserver(entries => {
            if (entries.length > 0) {
                const { width, height } = entries[0].contentRect;
                if (width !== dimensions.width || height !== dimensions.height) {
                    setDimensions({ width, height });
                }
            }
        });

        if (SeasonValuationSVGRef.current && SeasonValuationYAxisRef.current) {
            resizeObserver.observe(SeasonValuationSVGRef.current.parentElement!);
        }

        return () => resizeObserver.disconnect();
    }, [dimensions.width, dimensions.height]);



    useEffect(() => {

        if (!SeasonValuationYAxisRef.current || !SeasonValuationSVGRef.current) return;

        const SeasonValuationYAxisSVG = d3.select(SeasonValuationYAxisRef.current);
        const SeasonValuationSVG = d3.select(SeasonValuationSVGRef.current);
        const SeasonSVG = d3.select(SeasonSVGRef.current!);
        const DaysInjuredSVG = d3.select(DaysInjuredSVGRef.current!);
        const MinsPlayedSVG = d3.select(MinsPlayedSVGRef.current!)
        const GoalsSVG = d3.select(GoalsSVGRef.current!)
        const AssitsSVG = d3.select(AssitsSVGRef.current!)
        const AVGoalsSVG = d3.select(AVGoalsSVGRef.current!)
        const AVAssitsSVG = d3.select(AVAssitsSVGRef.current!)
        const AttributesYAxisSVG = d3.select(AttributesYAxisSVGRef.current!)
        // const AttributesSVG = d3.select(AttributesSVGRef.current!)
        AttributionSvg.current = attributionSVG.current && d3.select(attributionSVG.current)!;
        const CompetitionSVG = d3.select(CompetitionSVGRef.current!)
        const ContributionSVG = d3.select(ContributionSVGRef.current!)

        const { width, height } = dimensions;
        // const rectWidth: number = totalGraphWidth / transferValueSeasonData?.driver.length!;

        const colors = [theme.playerCardBackground, theme.playerContentBackground];
        const svgElements: SvgElementConfig[] = [
            { ref: SeasonValuationSVGRef, height: height, width: totalGraphWidth },
            { ref: SeasonValuationYAxisRef, height: height, width: 200 },
            { ref: SeasonSVGRef, height: 82, width: totalGraphWidth + margin.left + margin.right },
            { ref: DaysInjuredSVGRef, height: 50, width: totalGraphWidth + margin.left + margin.right },
            { ref: MinsPlayedSVGRef, height: 50, width: totalGraphWidth + margin.left + margin.right },
            { ref: GoalsSVGRef, height: 50, width: totalGraphWidth + margin.left + margin.right },
            { ref: AssitsSVGRef, height: 50, width: totalGraphWidth + margin.left + margin.right },
            { ref: AVGoalsSVGRef, height: 50, width: totalGraphWidth + margin.left + margin.right },
            { ref: AVAssitsSVGRef, height: 50, width: totalGraphWidth + margin.left + margin.right },
            { ref: AttributesYAxisSVGRef, height: attributeGraphHeight, width: 200 },
            { ref: attributionSVG, height: attributeGraphHeight, width: totalGraphWidth + margin.left + margin.right },
            { ref: CompetitionSVGRef, height: 50, width: totalGraphWidth + margin.left + margin.right },
            { ref: ContributionSVGRef, height: 121, width: totalGraphWidth + margin.left + margin.right }
        ];

        svgElements.forEach((element: SvgElementConfig) => {
            const svgSelection = d3.select(element.ref.current!);
            setSvgAttributes(svgSelection, element.width, element.height);
        });

        // Set up default and dynamic Y-axis divisions
        const defaultYAxisDivisions = Array.from({ length: 10 }, (_, i) => ({ value: i * 10 }));
        const yAxisDivisions = transferValueSeasonData?.yAxisDivisions?.length
            ? transferValueSeasonData.yAxisDivisions
            : defaultYAxisDivisions;

        // Define Y-axis scale
        const yScale = d3.scaleLinear()
            .domain([
                d3.min(yAxisDivisions, d => d.value)!,
                d3.max(yAxisDivisions, d => d.value)!
            ])
            .range([height - margin.top - margin.bottom, 0]);


        //SVG Group :
        const SeasonValuationGroup = createGroup(SeasonValuationSVG, margin);
        const TransferMarketYAxisGroup = createGroup(SeasonValuationYAxisSVG, margin);
        const SeasonGroup = createGroup(SeasonSVG, margin);
        const DaysInjuredGroup = createGroup(DaysInjuredSVG, margin)
        const MinsPlayedGroup = createGroup(MinsPlayedSVG, margin)
        const GoalsGroup = createGroup(GoalsSVG, margin)
        const AssitsGroup = createGroup(AssitsSVG, margin)
        const AVGoalsGroup = createGroup(AVGoalsSVG, margin)
        const AVAssitsGroup = createGroup(AVAssitsSVG, margin)
        const AttributesYAxisGroup = createGroup(AttributesYAxisSVG, margin)
        // const AttributesNewGroup = createGroup(AttributesSVG, margin)
        AttributesGroup.current = AttributionSvg.current && createGroup(AttributionSvg.current, margin);
        const CompetitionGroup = createGroup(CompetitionSVG, margin)
        const ContributionGroup = createGroup(ContributionSVG, margin)


        drawYAxis(transferValueSeasonData?.yAxisDivisions || [], SeasonValuationYAxisSVG, TransferMarketYAxisGroup, totalGraphWidth, yScale, height, margin);

        drawSeasonRect(SeasonValuationGroup,transferValueSeasonData?.driver || [],xScale,rectWidth,height,colors,
            (event, d) => {
                const rectX = xScale(d.seasonName);
                const clickX = event.offsetX;
        
                if (d.seasonTeamsData.length === 1) {
                    // showTooltip(event.pageX, event.pageY, d.seasonTeamsData[0]);
                    setSeasonValuationInfo(prevState => ({
                        transferMarketValue: d.seasonTeamsData[0].transferMarketValue,
                        seasonStartDate: new Date(d.seasonTeamsData[0].seasonStartDate).toLocaleDateString('en-GB'),
                        seasonEndDate: new Date(d.seasonTeamsData[0].seasonEndDate).toLocaleDateString('en-GB')
                    }));
                } else {
                    // Two teams, check click position
                    const clickedTeam = clickX < rectX! + rectWidth / 2 ? d.seasonTeamsData[0] : d.seasonTeamsData[1];
                    // showTooltip(event.pageX, event.pageY, clickedTeam);
                    setSeasonValuationInfo(prevState => ({
                        transferMarketValue: clickedTeam.transferMarketValue,
                        seasonStartDate: new Date(clickedTeam.seasonStartDate).toLocaleDateString('en-GB'),
                        seasonEndDate: new Date(clickedTeam.seasonEndDate).toLocaleDateString('en-GB')
                    }));
                }
                event.stopPropagation();
            }
        );
        
        // Call the function for DaysInjuredGroup without a click event
        drawSeasonRect(SeasonGroup,transferValueSeasonData?.driver || [],xScale,rectWidth,height,colors);
        drawSeasonRect(DaysInjuredGroup,transferValueSeasonData?.driver || [],xScale,rectWidth,height,colors);
        drawSeasonRect(MinsPlayedGroup,transferValueSeasonData?.driver || [],xScale,rectWidth,height,colors);
        drawSeasonRect(GoalsGroup,transferValueSeasonData?.driver || [],xScale,rectWidth,height,colors);
        drawSeasonRect(AssitsGroup,transferValueSeasonData?.driver || [],xScale,rectWidth,height,colors);
        drawSeasonRect(AVGoalsGroup,transferValueSeasonData?.driver || [],xScale,rectWidth,height,colors);
        drawSeasonRect(AVAssitsGroup,transferValueSeasonData?.driver || [],xScale,rectWidth,height,colors);
        drawSeasonRect(ContributionGroup,transferValueSeasonData?.driver || [],xScale,rectWidth,height,colors, (event, d) => {
            const rectX = xScale(d.seasonName);
            const clickX = event.offsetX;
    
            if (d.seasonTeamsData.length === 1) {
                // showTooltip(event.pageX, event.pageY, d.seasonTeamsData[0]);
                setSeasonContributionInfo(prevState => ({
                    contribution: d.seasonTeamsData[0].seasonFeaturesData.contributionFormUniversal,
                    seasonStartDate: new Date(d.seasonTeamsData[0].seasonStartDate).toLocaleDateString('en-GB'),
                    seasonEndDate: new Date(d.seasonTeamsData[0].seasonEndDate).toLocaleDateString('en-GB')
                }));
            } else {
                // Two teams, check click position
                const clickedTeam = clickX < rectX! + rectWidth / 2 ? d.seasonTeamsData[0] : d.seasonTeamsData[1];
                // showTooltip(event.pageX, event.pageY, clickedTeam);
                setSeasonContributionInfo(prevState => ({
                    contribution: clickedTeam.seasonFeaturesData.contributionFormUniversal,
                    seasonStartDate: new Date(clickedTeam.seasonStartDate).toLocaleDateString('en-GB'),
                    seasonEndDate: new Date(clickedTeam.seasonEndDate).toLocaleDateString('en-GB')
                }));
            }
            event.stopPropagation();
        });
        if (AttributesGroup?.current) {
            drawSeasonRect(AttributesGroup.current,transferValueSeasonData?.driver || [],xScale,rectWidth,attributeGraphHeight,colors,(event, d) => {
                const rectX = xScale(d.seasonName);
                const clickX = event.offsetX;
        
                if (d.seasonTeamsData.length === 1) {
                    // showTooltip(event.pageX, event.pageY, d.seasonTeamsData[0]);
                    setSeasonAttributesInfo(prevState => ({
                        finalThird: d.seasonTeamsData[0].finalThird,
                        buildUpPlay: d.seasonTeamsData[0].buildUpPlay ,
                        defence: d.seasonTeamsData[0].defence,
                        physical: d.seasonTeamsData[0].physical,
                        seasonStartDate: new Date(d.seasonTeamsData[0].seasonStartDate).toLocaleDateString('en-GB'),
                        seasonEndDate: new Date(d.seasonTeamsData[0].seasonEndDate).toLocaleDateString('en-GB')
                    }))
                } else {
                    // Two teams, check click position
                    const clickedTeam = clickX < rectX! + rectWidth / 2 ? d.seasonTeamsData[0] : d.seasonTeamsData[1];
                    // showTooltip(event.pageX, event.pageY, clickedTeam);
                    setSeasonAttributesInfo(prevState => ({
                        finalThird: clickedTeam.finalThird,
                        buildUpPlay: clickedTeam.buildUpPlay ,
                        defence: clickedTeam.defence,
                        physical: clickedTeam.physical,
                        seasonStartDate: new Date(clickedTeam.seasonStartDate).toLocaleDateString('en-GB'),
                        seasonEndDate: new Date(clickedTeam.seasonEndDate).toLocaleDateString('en-GB')
                    }));
                }
                event.stopPropagation();
            }
        );
        }
        
        const yValues = transferValueSeasonData?.yAxisDivisions.map(d => d.value) ?? Array.from({ length: 10 }, (_, i) => i * 10);
        drawHorizontalLines(SeasonValuationGroup, yValues, () => (-180), () => totalGraphWidth, (d: any) => yScale(d), (d: any) => yScale(d), "horizontal-line", theme.playerDataBorder, 1);

        const flatMarketValues = transferMarketValue?.flat() ?? [];

        const line = d3.line<any>()
            // .x(d => xScale(d.seas)! + xScale.bandwidth() / 2) // Center line in the band
            .x((d, i) => { return xData ? xData[i] : 0})
            .y(d => yScale(d.transferValue))
            .curve(d3.curveMonotoneX);

        drawLinePath(SeasonValuationGroup, flatMarketValues, d => xScale(d.uniqueKeyId)! + xScale.bandwidth() / 2, d => yScale(d.transferValue), "#FF7800", line!, 4);

        // Draw Rectangles
        // Get the last points from each dataset
        const lastTransferBenchMark = transferMarketValue[transferMarketValue?.length - 1];
        const lastTransferMarketValue = transferValueBenchmark[transferValueBenchmark?.length - 1];
        // Calculate the last point positions for the rectangle
        const lastTransferBenchMarkX = xData[xData?.length! - 1]!;
        const lastTransferBenchMarkY = yScale(lastTransferBenchMark?.transferValue);

        const lastTransferMarketValueX = lastTransferMarketValue
            ?  xData?.length : 0;

        const lastTransferMarketValueY = lastTransferMarketValue
            ? yScale(lastTransferMarketValue?.transferValue) : 0;

        // Rectangle dimensions
        const rectHeight = 20;
        // Check if the lines are close enough
        const distanceThreshold = 20; // Adjust based on your scale
        const yDistance = Math.abs(lastTransferBenchMarkY - lastTransferMarketValueY);

        if (yDistance <= distanceThreshold) {
            // Draw a single rectangle for both values
            const rectY = (lastTransferBenchMarkY + lastTransferMarketValueY) / 2 - rectHeight / 2; // Center the rect vertically
            createRectangleAndText(SeasonValuationGroup, lastTransferBenchMarkX, rectY, rectWidth, rectHeight, lastTransferMarketValue?.transferValueText || '', theme.secondaryButtonBackground, theme.playerColor);
        } else {
            // Draw separate rectangles for each value
            // Rectangle for TransferBenchMarkData
            createRectangleAndText(SeasonValuationGroup, lastTransferBenchMarkX, lastTransferBenchMarkY, rectWidth, rectHeight, lastTransferBenchMark?.transferValueText, theme.secondaryButtonBackground, theme.playerColor);
            if (lastTransferMarketValue?.transferValueText) {
                // Rectangle for TranferMarketValue
                // createRectangleAndText(SeasonValuationGroup, lastTransferMarketValueX, lastTransferMarketValueY, rectWidth, rectHeight, lastTransferMarketValue?.transferValueText || '', theme.secondaryButtonBackground, theme.playerColor);
            }
        }


        renderSeasonData(seasonData, SeasonGroup, xScale, yScale, theme);
        drawHorizontalLines(SeasonGroup, [1], () => (-180), () => totalGraphWidth, (d: any) => 80, (d: any) => 80, "horizontal-line", theme.playerDataBorder, 1);

        const daysInjuredData = seasonData.flatMap(season => season.seasonFeaturesData) || [];


        renderBottomGraphText(DaysInjuredGroup, daysInjuredData, xScale, d => `${d.injuredDays}`);
        renderBottomGraphText(MinsPlayedGroup, daysInjuredData, xScale, d => `${d.percentageMinsPlayed}`);
        renderBottomGraphText(GoalsGroup, daysInjuredData, xScale, d => `${d.totalGoals}`);
        renderBottomGraphText(AssitsGroup, daysInjuredData, xScale, d => `${d.totalAssists}`);
        renderBottomGraphText(AVGoalsGroup, daysInjuredData, xScale, d => `${d.averageXGoals}`, true);
        renderBottomGraphText(AVAssitsGroup, daysInjuredData, xScale, d => `${d.averageXAssists}`, true);

        let finalThirdEndPoints: LineEnd[] = [];


        //render Attribute data
        if (AttributionSvg.current) {
           
            const yScaleDifference = 10;
            const generateTicks = (minValue: number, maxValue: number, step: number) => {
                return d3.range(
                    Math.floor(minValue / step) * step,
                    Math.ceil(maxValue / step) * step + 1,
                    step
                );
            };
            const yTicks = generateTicks(minFinalScore, maxFinalScore, yScaleDifference);
            const finalThirdTicks = generateTicks(finalThirdminValue, FinalThirdmaxValue, yScaleDifference);
            const buildUpPlayTicks = generateTicks(buildUpPlayminValue, buildUpPlaymaxValue, 10);
            const defenceTicks = generateTicks(defenceminValue, defencemaxValue, 10);
            const physicalTicks = generateTicks(physicalminValue, physicalmaxValue, 10);

            const path = (svgGrp: any, data: any, color: string, lineGenerator: any, yValue?: string, endPoints?: LineEnd[], scale?: any,
                className?: string
            ) => {
                // Draw the path (the line)
                if (data && data.length > 0) {
                    svgGrp.append("path")
                        .datum(data)
                        .attr("class", className)
                        .attr("fill", "none")
                        .attr("stroke", color)
                        .attr("stroke-width", 4)
                        .attr("d", lineGenerator);

                    if (yValue && endPoints && data) {
                        // Get the end point for the line (last point in the dataset)
                        const lastPointIndex = data.length - 1;
                        const endPoint: LineEnd = {
                            data: {
                                x: xScale(data[lastPointIndex]?.seasonName)! + xScale.bandwidth() / 2,
                                y: scale(data[lastPointIndex][yValue]),
                                value: data[lastPointIndex][yValue],
                                color: color
                            },
                        };
                        // Add the end point to the array
                        endPoints.push(endPoint);
                    }

                }

            }

            if (selectedAttribute.isFinalThird) {
                if (allFinalScoreZero) { sethasfinalthirdNoAttributes(allFinathirdZero) }
            }
            if (selectedAttribute.isBuildUpPlay) {
                if (allBuildUpPlayZero) { sethasbuildupNoAttributes(allBuildUpPlayZero) }
            }
            if (selectedAttribute.isDefence) {
                if (allDefenceZero) { sethasdefenceNoAttributes(allDefenceZero) }
            }
            if (selectedAttribute.isPhysical) {
                if (allAttributesAreZero) { sethasNoAttributes(allAttributesAreZero) }
            }



            switch (true) {
                case selectedAttribute.isFinalThird:
                    finalThirdEndPoints = [];
                    updateAttributeYAxis.current = drawAttributeYAxis(AttributesYAxisGroup, AttributesGroup.current!, finalThirdTicks, finalThirdScale, theme,
                        totalGraphWidth, 0, 198, 170, 12);
                    if (!hasfinalthirdNoAttributes && finalThirdData.length > 0) {
                        //drawFinalThirdPaths(AttributesGroup, finalThirdData, lineGenerators)
                        !hasfinalthirdNoAttributes && path(AttributesGroup.current, finalThirdData, "#FF3864", lineGenerators.finalThird.finishingShots, 'finishingShots', finalThirdEndPoints, finalThirdScale, 'finalThirdPath finishingShots');
                        !hasfinalthirdNoAttributes && path(AttributesGroup.current, finalThirdData, "#00A1E4", lineGenerators.finalThird.finishingAerial, 'finishingAerial', finalThirdEndPoints, finalThirdScale, 'finalThirdPath finishingAerial');
                        !hasfinalthirdNoAttributes && path(AttributesGroup.current, finalThirdData, "#F2E94E", lineGenerators.finalThird.attackPositioning, 'attackPositioning', finalThirdEndPoints, finalThirdScale, 'finalThirdPath attackPositioning');
                        elements = drawMergedRectangles(AttributesGroup.current, finalThirdEndPoints, 25, finalThirdScale);
                    }
                    break;

                case selectedAttribute.isBuildUpPlay:
                    const buildupEndPoints: LineEnd[] = [];
                    updateAttributeYAxis.current = drawAttributeYAxis(AttributesYAxisGroup, AttributesGroup.current!, buildUpPlayTicks, buildUpPlayScale, theme,
                        totalGraphWidth, 0, 198, 170, 12);
                    if (!hasbuildupNoAttributes && buildupPlayData.length > 0) {
                        //drawBuildUpPlayPaths(AttributesGroup, buildupPlayData, lineGenerators)
                        !hasbuildupNoAttributes && path(AttributesGroup.current, buildupPlayData, "#FF3864", lineGenerators.buildUpPlay.creativity, 'creativity', buildupEndPoints, buildUpPlayScale, 'buildUpPath creativity');
                        !hasbuildupNoAttributes && path(AttributesGroup.current, buildupPlayData, "#00A1E4", lineGenerators.buildUpPlay.crossing, 'crossing', buildupEndPoints, buildUpPlayScale, 'buildUpPath crossing');
                        !hasbuildupNoAttributes && path(AttributesGroup.current, buildupPlayData, "#F2E94E", lineGenerators.buildUpPlay.dribbling, 'dribbling', buildupEndPoints, buildUpPlayScale, 'buildUpPath dribbling');
                        !hasbuildupNoAttributes && path(AttributesGroup.current, buildupPlayData, "#4AF075", lineGenerators.buildUpPlay.passingAccuracy, 'passingAccuracy', buildupEndPoints, buildUpPlayScale, 'buildUpPath passingAccuracy');
                        elements = drawMergedRectangles(AttributesGroup.current, buildupEndPoints, 25, buildUpPlayScale); // Call to draw merged rectangles
                    }
                    break;

                case selectedAttribute.isDefence:
                    const defenceEndPoints: LineEnd[] = [];
                    updateAttributeYAxis.current = drawAttributeYAxis(AttributesYAxisGroup, AttributesGroup.current!, defenceTicks, defenceScale, theme,
                        totalGraphWidth, 0, 198, 170, 12);
                    if (!hasdefenceNoAttributes && defenceData.length > 0) {
                        !hasdefenceNoAttributes && path(AttributesGroup.current, defenceData, "#FF3864", lineGenerators.defence.aggression, 'aggression', defenceEndPoints, defenceScale, "defencePath aggression");
                        !hasdefenceNoAttributes && path(AttributesGroup.current, defenceData, "#00A1E4", lineGenerators.defence.defensiveHeaders, 'defensiveHeaders', defenceEndPoints, defenceScale, "defencePath defensiveHeaders");
                        !hasdefenceNoAttributes && path(AttributesGroup.current, defenceData, "#F2E94E", lineGenerators.defence.tackling, 'tackling', defenceEndPoints, defenceScale, "defencePath tackling");
                        elements = drawMergedRectangles(AttributesGroup.current, defenceEndPoints, 25, defenceScale); // Call to draw merged rectangles
                    }

                    break;

                case selectedAttribute.isPhysical:
                    const physicalEndPoints: LineEnd[] = [];
                    updateAttributeYAxis.current = drawAttributeYAxis(AttributesYAxisGroup, AttributesGroup.current!, physicalTicks, physicalScale, theme,
                        totalGraphWidth, 0, 198, 170, 12);
                    if (!hasNoAttributes && physicalData.length > 0) {
                        !hasNoAttributes && path(AttributesGroup.current, physicalData, "#FF3864", lineGenerators.physical.speed, 'speed', physicalEndPoints, physicalScale, "physicalPath speed");
                        !hasNoAttributes && path(AttributesGroup.current, physicalData, "#00A1E4", lineGenerators.physical.strength, 'strength', physicalEndPoints, physicalScale, "physicalPath strength");
                        !hasNoAttributes && path(AttributesGroup.current, physicalData, "#F2E94E", lineGenerators.physical.workRate, 'workRate', physicalEndPoints, physicalScale, "physicalPath workRate");
                        !hasNoAttributes && drawMergedRectangles(AttributesGroup.current, physicalEndPoints, 25, physicalScale);
                        //drawPhysicalPaths(AttributesGroup, physicalData, lineGenerators)
                    }

                    break;

                default:
                    const defaultEndPoints: LineEnd[] = [];
                    updateAttributeYAxis.current = drawAttributeYAxis(AttributesYAxisGroup, AttributesGroup.current!, yTicks, attributesYScale, theme,
                        totalGraphWidth, 0, 198, 170, 12);
                    !allFinalScoreZero && path(AttributesGroup.current!, finalThirdData, "#00D1A8", attributesLinePath, 'finalScore', defaultEndPoints, attributesYScale);
                    !allFinalScoreZero && path(AttributesGroup.current!, buildupPlayData, "#FF7800", attributesLinePath, 'finalScore', defaultEndPoints, attributesYScale);
                    !allFinalScoreZero && path(AttributesGroup.current!, defenceData, "#C9F0B5", attributesLinePath, 'finalScore', defaultEndPoints, attributesYScale);
                    !allFinalScoreZero && path(AttributesGroup.current!, physicalData, "#FFC2C2", attributesLinePath, 'finalScore', defaultEndPoints, attributesYScale);
                    !allFinalScoreZero && drawMergedRectangles(AttributesGroup.current, defaultEndPoints, 25, attributesYScale)
                    break;
            }
        }
       
        const competitionMap = new Map<number, any>();

        // inputData.driver.forEach(({ seasonTeamsData }) => {
        seasonData.forEach(team => {
            const compId = team.competitionId;

            if (!competitionMap.has(compId)) {
                competitionMap.set(compId, {
                    competitionId: team.competitionId,
                    competitionName: team.competitionName,
                    competitionImageURL: team.competitionImageURL,
                    competitionCountryName: team.competitionCountryName,
                    competitionCountryAlpha3Code: team.competitionCountryAlpha3Code,
                    competitionCode: team.competitionCode,
                    teams: []
                });
            }

            const competition = competitionMap.get(compId)!;

            if (!competition.teams.some((t: any) => t.uniqueKeyId === team.uniqueKeyId)) {
                competition.teams.push(team);
            }
        });
        // });

        const CompetionsData = Array.from(competitionMap.values());

        renderCompetitions(CompetitionGroup,CompetionsData!, rectWidth, theme)


        // Draw wicks (high-low lines)
        ContributionGroup.selectAll(".wick")
            .data(contributionData)
            .enter()
            .append("line")
            //.attr("class", "wick")
            .attr("x1", (d , i )=> xData ? xData[i] : 0)
            .attr("x2", (d , i )=> xData ? xData[i] : 0)
            .attr("y1", d => contributionYScale(d.highestValue))
            .attr("y2", d => contributionYScale(d.lowestValue))
            .attr('stroke', d => d.openingValue > d.closingValue ? "#FFA3B8" : "#B7DAA6")
            .style("stroke-width", "1px");

        // Draw candlesticks
        ContributionGroup.selectAll(".candle")
            .data(contributionData)
            .enter()
            .append("rect")
            //.attr("class", "candle")
            .attr("x", (d , i )=> xData ? xData[i] - 20: 0)
            .attr("y", d => contributionYScale(Math.max(d.openingValue, d.closingValue))) // Top of the rectangle
            .attr("rx", 4)
            .attr("ry", 4)
            .attr("width", xScale.bandwidth() / 4)
            .attr("height", d => Math.abs(contributionYScale(d.openingValue) - contributionYScale(d.closingValue)) + 2) // Height based on price difference
            .attr("fill", d => d.openingValue > d.closingValue ? "#FFC1CF" : "#C9F0B5"); // Red for down, green for up


    }, [dimensions, transferValueSeasonData, theme, selectedGraph, selectedAttribute, isLeague , attributeGraphHeight])


    const zoom: d3.ZoomBehavior<SVGSVGElement, unknown> = d3.zoom<SVGSVGElement, unknown>()
            .scaleExtent([1, 5]) // Set zoom range
            .translateExtent([
                [0, 0],
                [totalGraphWidth, attributeGraphHeight],
            ])
            .filter((event) => {
                // Allow only panning, disable zooming on mouse wheel and double-click
                return !event.ctrlKey && event.type !== "wheel" && event.type !== "dblclick";
            })
            .on("zoom", (event) => {
    
                if (!updateAttributeYAxis.current) return;
                const attributeYAxisContainer = document.getElementById("attributeYAxisContainer");
                const attributesCharts = document.getElementById("attributesCharts");
                const transform = event.transform;
                setCurrentScale(transform.k);
                let newHeight = attributionGraphBaseHeight * transform.k;
                setAttributeGraphHeight(newHeight);
                d3.select("#attributeYAxisSVG").attr("height", newHeight);
                attributeYAxisContainer!.style.height = `${newHeight}px`;
                d3.select("#attributeSVG").attr("height", newHeight);
                attributesCharts!.style.height = `${newHeight}px`;
                // Rescale the y-axis scale based on the zoom transform
                let currentAttributeYScale = getAttributeYScale(selectedAttribute);
    
                const newAttributeYScale = transform.rescaleY(currentAttributeYScale)
                    .range([newHeight - bottomPadding, padding]);
                const [attributeYMin, attributeYMax] = newAttributeYScale.domain();
    
                const rescaledAttributeY = d3.scaleLinear()
                    .domain([attributeYMin, attributeYMax]) // Adjusted domain
                    .range([newHeight - bottomPadding, padding]);
    
                updateAttributeYAxis.current(rescaledAttributeY);
                const onzoomLevel = transform.k;
    
                const isZoomingIn = onzoomLevel > 1;
                // setCurrentScale(event.transform.k);
    
                // Hide elements when zooming in, show when zooming out
                // d3.selectAll(".merged-rect").style("opacity", isZoomingIn ? 0 : 1);
                // d3.selectAll(".merged-circle").style("opacity", isZoomingIn ? 0 : 1);
                // d3.selectAll(".merged-text").style("opacity", isZoomingIn ? 0 : 1);
                switch (true) {
                    case selectedAttribute.isFinalThird:
                        pathClass = ".finalThirdPath";
                        lineGenerator = lineGenerators.finalThird;
                        break;
                    case selectedAttribute.isBuildUpPlay:
                        pathClass = ".buildUpPath";
                        lineGenerator = lineGenerators.buildUpPlay;
                        break;
                    case selectedAttribute.isDefence:
                        pathClass = ".defencePath";
                        lineGenerator = lineGenerators.defence;
                        break;
                    case selectedAttribute.isPhysical:
                        pathClass = ".physicalPath";
                        lineGenerator = lineGenerators.physical;
                        break;
                    default:
                        AttributesGroup.current!.selectAll("path")
                            .transition()
                            .duration(100)
                            //.datum(finalThirdData)
                            .attr("d", (d: any) => attributesLinePath.y((d) => rescaledAttributeY(d.finalScore))(d));
                        return;
                }
                // Other zoom operations...
                const paths = AttributesGroup.current!.selectAll(pathClass);
                paths.each(function (d: any) {
                    const path = d3.select(this);
                    const pathData = getPathData(path, d, lineGenerator, rescaledAttributeY);
    
                    // Apply Y-axis scaling only (prevent X-scaling)
                    path.attr("transform", `translate(0, ${transform.y}) scale(1, ${transform.k})`);
                    path.style("display", "block");
    
                    // Keep stroke width constant
                    path.style("vector-effect", "non-scaling-stroke") // Prevents stroke from scaling
                        .style("stroke-width", "4px"); // Fixed width in pixels
    
                    // Apply rescaling for the y-values based on zoom
                    const rescaledYPathData = rescalePathData(pathData, rescaledAttributeY);
    
                    // Update path with the new data
                    path.transition().duration(200).attr("d", rescaledYPathData);
                });
            });
    
    
        const zoomIn = () => {
            if (attributionSVG.current && totalGraphWidth > 0 && attributeGraphHeight > 0) {
                const svgElement = d3.select(attributionSVG.current);
                svgElement.transition().call(zoom.scaleBy, 1.5); // Zoom in by a factor of 1.2
            }
        };
    
        // Zoom Out function
        const zoomOut = () => {
            if (attributionSVG.current && totalGraphWidth > 0 && attributeGraphHeight > 0) {
                const svgElement = d3.select(attributionSVG.current);
                svgElement.transition().call(zoom.scaleBy, 0.66); // Zoom out by a factor of 0.8
            }
        };

    const handleAttributeClick = (attributeKey: keyof SelectedAttribute) => {
        setSelectedAttribute((prevState: any) => {
            // Create a new state object where all attributes are set to false
            const newState: any = {
                isFinalThird: false,
                isBuildUpPlay: false,
                isDeefence: false,
                isPhysical: false
            };

            // Set the clicked attribute to true
            newState[attributeKey] = !prevState[attributeKey];

            return newState;
        });
        if (attributeKey === 'isFinalThird') {
            if (allFinalScoreZero) { sethasfinalthirdNoAttributes(allFinathirdZero) }
        }
        if (attributeKey === 'isBuildUpPlay') {
            if (allBuildUpPlayZero) { sethasbuildupNoAttributes(allBuildUpPlayZero) }
        }
        if (attributeKey === "isDefence") {
            if (allDefenceZero) { sethasdefenceNoAttributes(allDefenceZero) }
        }
        if (attributeKey === "isPhysical") {
            if (allAttributesAreZero) { sethasNoAttributes(allAttributesAreZero) }
        }
    };

    const renderSeasonValuationInfoCard = () => {
        return (
            <div className='valation-info-container'>
                <div className='valuation-info-header'>
                    <LabelText className='player-search-text'>{seasonValuationInfo?.seasonStartDate} - {seasonValuationInfo?.seasonEndDate} </LabelText>
                    <CloseIcon onClick={() => { setSeasonValuationInfo(null) }} sx={{ color: '#7C7D79', width: '24px', height: '24px', cursor: 'pointer' }} />
                </div>
                <div className='valuation-info-values-container'>
                    {/* <div className='valuation-info-values'>
                        <div className='square-box'></div>
                        <LabelNumber className='percentile-text'>MF market valuation</LabelNumber>
                        <LabelNumber className='player-card-value' style={{flex:'1 0 0'}}>£</LabelNumber>
                    </div> */}
                    <div className='valuation-info-values'>
                        <div className='square-box transfer-market'></div>
                        <LabelNumber className='percentile-text'>TransferMarkt valuation</LabelNumber>
                        <LabelNumber className='player-card-value' style={{ flex: '1 0 0' }}>£{seasonValuationInfo?.transferMarketValue.transferValueText}</LabelNumber>
                    </div>
                </div>
            </div>
        )

    }

    const renderAttributesInfoCard = () => {
        return (
            <div className='attributes-info-main'>
                {/* <div style={{borderBottom : '1px solid #DADADA'}}></div> */}
                <div className='attributes-info-header'>
                    <LabelText className='player-search-text'>{seasonAtrributesInfo?.seasonStartDate} - {seasonAtrributesInfo?.seasonEndDate} </LabelText>
                    <CloseIcon onClick={() => { setSeasonAttributesInfo(null) }} sx={{ color: '#7C7D79', width: '24px', height: '24px', cursor: 'pointer' }} />

                </div>
                <div className={`attributes-info-container ${!selectedInfoAttribute?.isFinalThird ? 'with-border' : ''}`}>
                    <div className='square-box'></div>
                    <LabelText className='player-given-name'>Final third</LabelText>
                    <LabelNumber style={{ flex: '1 0 0' }}>{seasonAtrributesInfo?.finalThird.finalScore}</LabelNumber>
                    {selectedInfoAttribute.isFinalThird && (<ExpandLessIcon className='expand-icon' onClick={() => setSelectedInfoAttribute((prev) => ({ ...prev, isFinalThird: false, }))} />)}
                    {!selectedInfoAttribute.isFinalThird && (
                        <ExpandMoreIcon className='expand-icon' onClick={() => setSelectedInfoAttribute((prev) => ({ ...prev, isFinalThird: true, }))} />
                    )}


                </div>
                {selectedInfoAttribute.isFinalThird && (
                    <div className={`valuation-info-values-container ${selectedInfoAttribute?.isFinalThird ? 'with-border' : ''}`} >
                        <div className='valuation-info-values'>
                            <LabelNumber className='percentile-text'>Finishing - Shots</LabelNumber>
                            <LabelNumber className='player-card-value' style={{ flex: '1 0 0' }}>{seasonAtrributesInfo?.finalThird.finishingShots}</LabelNumber>
                        </div>
                        <div className='valuation-info-values'>
                            <LabelNumber className='percentile-text'>Finishing - Aerial</LabelNumber>
                            <LabelNumber className='player-card-value' style={{ flex: '1 0 0' }}>{seasonAtrributesInfo?.finalThird.finishingAerial}</LabelNumber>
                        </div>
                        <div className='valuation-info-values'>
                            <LabelNumber className='percentile-text'>Attack positioning</LabelNumber>
                            <LabelNumber className='player-card-value' style={{ flex: '1 0 0' }}>{seasonAtrributesInfo?.finalThird.attackPositioning}</LabelNumber>
                        </div>
                    </div>
                )}
                <div className={`attributes-info-container ${!selectedInfoAttribute?.isBuildUpPlay ? 'with-border' : ''}`}>

                    <div className='square-box transfer-market'></div>
                    <LabelText className='player-given-name'>Build up play</LabelText>
                    <LabelNumber style={{ flex: '1 0 0' }}>{seasonAtrributesInfo?.buildUpPlay.finalScore}</LabelNumber>
                    {selectedInfoAttribute.isBuildUpPlay && (<ExpandLessIcon className='expand-icon' onClick={() => setSelectedInfoAttribute((prev) => ({ ...prev, isBuildUpPlay: false, }))} />)}
                    {!selectedInfoAttribute.isBuildUpPlay && (
                        <ExpandMoreIcon className='expand-icon' onClick={() => setSelectedInfoAttribute((prev) => ({ ...prev, isBuildUpPlay: true, }))} />
                    )}

                </div>
                {selectedInfoAttribute.isBuildUpPlay && (
                    <div className={`valuation-info-values-container ${selectedInfoAttribute?.isBuildUpPlay ? 'with-border' : ''}`} >
                        <div className='valuation-info-values'>
                            <LabelNumber className='percentile-text'>creativity</LabelNumber>
                            <LabelNumber className='player-card-value' style={{ flex: '1 0 0' }}>{seasonAtrributesInfo?.buildUpPlay.creativity}</LabelNumber>
                        </div>
                        <div className='valuation-info-values'>
                            <LabelNumber className='percentile-text'>crossing</LabelNumber>
                            <LabelNumber className='player-card-value' style={{ flex: '1 0 0' }}>{seasonAtrributesInfo?.buildUpPlay.crossing}</LabelNumber>
                        </div>
                        <div className='valuation-info-values'>
                            <LabelNumber className='percentile-text'>dribbling</LabelNumber>
                            <LabelNumber className='player-card-value' style={{ flex: '1 0 0' }}>{seasonAtrributesInfo?.buildUpPlay.dribbling}</LabelNumber>
                        </div>
                        <div className='valuation-info-values'>
                            <LabelNumber className='percentile-text'>passing accuracy</LabelNumber>
                            <LabelNumber className='player-card-value' style={{ flex: '1 0 0' }}>{seasonAtrributesInfo?.buildUpPlay.passingAccuracy}</LabelNumber>
                        </div>
                    </div>
                )}
                <div className={`attributes-info-container ${!selectedInfoAttribute?.isDefence ? 'with-border' : ''}`}>

                    <div className='square-box defence'></div>
                    <LabelText className='player-given-name'>Defence</LabelText>
                    <LabelNumber style={{ flex: '1 0 0' }}>{seasonAtrributesInfo?.defence.finalScore}</LabelNumber>
                    {selectedInfoAttribute.isDefence && (<ExpandLessIcon className='expand-icon' onClick={() => setSelectedInfoAttribute((prev) => ({ ...prev, isDefence: false, }))} />)}
                    {!selectedInfoAttribute.isDefence && (
                        <ExpandMoreIcon className='expand-icon' onClick={() => setSelectedInfoAttribute((prev) => ({ ...prev, isDefence: true, }))} />
                    )}

                </div>
                {selectedInfoAttribute.isDefence && (
                    <div className={`valuation-info-values-container ${selectedInfoAttribute?.isDefence ? 'with-border' : ''}`} >
                        <div className='valuation-info-values'>
                            <LabelNumber className='percentile-text'>ball recovery</LabelNumber>
                            <LabelNumber className='player-card-value' style={{ flex: '1 0 0' }}>{seasonAtrributesInfo?.defence.aggression}</LabelNumber>
                        </div>
                        <div className='valuation-info-values'>
                            <LabelNumber className='percentile-text'>defensive Headers</LabelNumber>
                            <LabelNumber className='player-card-value' style={{ flex: '1 0 0' }}>{seasonAtrributesInfo?.defence.defensiveHeaders}</LabelNumber>
                        </div>
                        <div className='valuation-info-values'>
                            <LabelNumber className='percentile-text'>tackling</LabelNumber>
                            <LabelNumber className='player-card-value' style={{ flex: '1 0 0' }}>{seasonAtrributesInfo?.defence.tackling}</LabelNumber>
                        </div>
                    </div>
                )}
                <div className='attributes-info-container'>
                    <div className='square-box physical'></div>
                    <LabelText className='player-given-name'>Physical</LabelText>
                    <LabelNumber style={{ flex: '1 0 0' }}>{seasonAtrributesInfo?.physical.finalScore}</LabelNumber>
                    {selectedInfoAttribute.isPhysical && (<ExpandLessIcon className='expand-icon' onClick={() => setSelectedInfoAttribute((prev) => ({ ...prev, isPhysical: false, }))} />)}
                    {!selectedInfoAttribute.isPhysical && (
                        <ExpandMoreIcon className='expand-icon' onClick={() => setSelectedInfoAttribute((prev) => ({ ...prev, isPhysical: true, }))} />
                    )}


                </div>
                {selectedInfoAttribute.isPhysical && (
                    <div className='valuation-info-values-container'>
                        <div className='valuation-info-values'>
                            <LabelNumber className='percentile-text'>speed</LabelNumber>
                            <LabelNumber className='player-card-value' style={{ flex: '1 0 0' }}>{seasonAtrributesInfo?.physical.speed}</LabelNumber>
                        </div>
                        <div className='valuation-info-values'>
                            <LabelNumber className='percentile-text'>strength</LabelNumber>
                            <LabelNumber className='player-card-value' style={{ flex: '1 0 0' }}>{seasonAtrributesInfo?.physical.strength}</LabelNumber>
                        </div>
                        <div className='valuation-info-values'>
                            <LabelNumber className='percentile-text'>work rate</LabelNumber>
                            <LabelNumber className='player-card-value' style={{ flex: '1 0 0' }}>{seasonAtrributesInfo?.physical.workRate}</LabelNumber>
                        </div>
                    </div>
                )}
            </div>
        )
    }

    const renderCandleInfoCard = () => {
        const difference = seasonContrinutionInfo?.contribution.closingValue! - seasonContrinutionInfo?.contribution.openingValue!;
        const formattedDifference = difference >= 0 ? `+${difference}` : `${difference}`;
        return (
            <div className='candle-info-main'>
                <div className='candle-info-header'>
                    <LabelText className='player-search-text'>{seasonContrinutionInfo?.seasonStartDate} - {seasonContrinutionInfo?.seasonEndDate}</LabelText>
                    <CloseIcon onClick={() => { setSeasonContributionInfo(null) }} sx={{ color: '#7C7D79', width: '24px', height: '24px', cursor: 'pointer' }} />
                </div>
                <div className='candle-info-container'>
                    <div className='candle-info-content'>
                        <LabelNumber className='percentile-text'>Start of season value</LabelNumber>
                        <LabelNumber className='player-card-value'>{seasonContrinutionInfo?.contribution.openingValue}</LabelNumber>
                    </div>
                    <div className='candle-info-content'>
                        <LabelNumber className='percentile-text'>End of season value</LabelNumber>
                        <LabelNumber className='player-card-value'>{seasonContrinutionInfo?.contribution.closingValue}</LabelNumber>
                    </div>
                    <div className='candle-info-content'>
                        <LabelNumber className='percentile-text' >Change</LabelNumber>
                        <LabelNumber className='player-card-value' style={{ color: seasonContrinutionInfo?.contribution.isChangePositive ? '#00D1A8' : '#FF3864' }}>{formattedDifference}</LabelNumber>
                    </div>
                    <div className='candle-info-content'>
                        <LabelNumber className='percentile-text'>Highest season value</LabelNumber>
                        <LabelNumber className='player-card-value'>{seasonContrinutionInfo?.contribution.highestValue}</LabelNumber>
                    </div>
                    <div className='candle-info-content'>
                        <LabelNumber className='percentile-text'>Lowest season value</LabelNumber>
                        <LabelNumber className='player-card-value'>{seasonContrinutionInfo?.contribution.lowestValue}</LabelNumber>
                    </div>
                </div>
            </div>
        )

    }

    const handlePositionToggle = () => {
        // startLoading();
        setIsLeague(prevState => !prevState);
    };


    return (
        <>
            <div className={`value-graph-chart ${isFullView && 'fullview-chart'} `}>
                <YAxisContainer>
                    <SvgStyled ref={SeasonValuationYAxisRef} style={{borderBottom :'2px solid #DADADA'}}/>
                    <BottomSideBar className='bottom-sidebar'>
                        <BottomLeftContainer className='season-drivers'>
                            {isFullView && (
                                <div className='drivers-matches'>
                                    <LabelNumber className='club-info-value'>Drivers</LabelNumber>
                                    <CustomDropdown
                                        options={Options}
                                        deafaultSelected='Football'
                                        onChange={handleValueGraphChange}
                                        className='value-graph-dropdown'
                                        isDisplaySearchInput={false}
                                    />
                                </div>
                            )}
                        </BottomLeftContainer>
                        {isFullView && selectedGraph === 'Football' && (
                            <>
                                <BottomLeftContainer className='days-injured'>
                                    <div className='drivers-matches'>
                                        <LabelText className='overall-text'>Days injured</LabelText>
                                    </div>
                                </BottomLeftContainer>
                                <BottomLeftContainer className='days-injured'>
                                    <div className='drivers-matches'>
                                        <LabelText className='overall-text'>% Mins played</LabelText>
                                    </div>
                                </BottomLeftContainer>
                                <BottomLeftContainer className='days-injured'>
                                    <div className='drivers-matches'>
                                        <LabelText className='overall-text'>Goals</LabelText>
                                    </div>
                                </BottomLeftContainer>
                                <BottomLeftContainer className='days-injured'>
                                    <div className='drivers-matches'>
                                        <LabelText className='overall-text'>Assists</LabelText>
                                    </div>
                                </BottomLeftContainer>
                                <BottomLeftContainer className='contribution-svg'>
                                    <div className='drivers-matches'>
                                        <LabelText className='overall-text'>Contribution/
                                            Form</LabelText>
                                    </div>
                                </BottomLeftContainer>
                                <BottomLeftContainer className='days-injured'>
                                    <div className='drivers-matches'>
                                        <LabelText className='overall-text'>av. x Goals</LabelText>
                                    </div>
                                </BottomLeftContainer>
                                <BottomLeftContainer className='days-injured'>
                                    <div className='drivers-matches'>
                                        <LabelText className='overall-text'>av. x Assists</LabelText>
                                    </div>
                                </BottomLeftContainer>
                            </>
                        )}
                        {isFullView && selectedGraph === 'Attribute-score' && (
                            <>
                                <div id="attributeYAxisContainer"><svg ref={AttributesYAxisSVGRef} id="attributeYAxisSVG" /></div>
                                <div className="zoom-buttons-container">
                                    <SecondaryButton iconType='zoomout' onClick={zoomOut} disabled={currentScale <= 1} />
                                    <SecondaryButton iconType='zoomin' onClick={zoomIn} disabled={currentScale >= 4} />
                                </div>
                            </>
                        )}
                    </BottomSideBar>
                </YAxisContainer>
                <div className={isFullView ? 'scrollbar-container-fullview' : 'scrollbar-container'}>
                    {isLoading && <ModuleSpinner isLargeLoading={isFullView} />}
                    <div className='testing' style={{ background:`url(${noDataBackground})`}}>
                        <div className='value-graph-chart-top-svg'>
                            <SvgStyled ref={SeasonValuationSVGRef} style={{borderRight :'2px solid #DADADA'}}/>
                            {seasonValuationInfo && isFullView && renderSeasonValuationInfoCard()}

                        </div>
                        <div className='value-graph-chart-bottom-svg'>
                        {/* {isFullView && transferValueSeasonData && (<LabelNumber className='attack-defense-data' style={{transform: 'rotate(-90deg)',position:'absolute',marginRight:totalGraphWidth-80,bottom:isFullView ?'440px' : ''}}>Player data start date</LabelNumber>)} */}

                            <div className='season-drivers'><SvgStyled ref={SeasonSVGRef} style={{borderRight :'2px solid #DADADA',direction:'rtl'}}/></div>
                            {isFullView && selectedGraph === 'Football' && (
                                <>
                                    <div className='days-injured'><SvgStyled ref={DaysInjuredSVGRef} style={{borderRight :'2px solid #DADADA'}}/></div>
                                    <div className='days-injured'><SvgStyled ref={MinsPlayedSVGRef} style={{borderRight :'2px solid #DADADA'}}/></div>
                                    <div className='days-injured'><SvgStyled ref={GoalsSVGRef} style={{borderRight :'2px solid #DADADA'}}/></div>
                                    <div className='days-injured'><SvgStyled ref={AssitsSVGRef} style={{borderRight :'2px solid #DADADA'}}/></div>
                                    <div className='contribution-svg'><SvgStyled ref={ContributionSVGRef} style={{borderRight :'2px solid #DADADA'}}/></div>
                                    <div className='days-injured'><SvgStyled ref={AVGoalsSVGRef} style={{borderRight :'2px solid #DADADA'}}/></div>
                                    <div className='days-injured'><SvgStyled ref={AVAssitsSVGRef} style={{borderRight :'2px solid #DADADA'}}/></div>
                                    {seasonContrinutionInfo && renderCandleInfoCard()}
                                </>

                            )}

                            {isFullView && selectedGraph === 'Attribute-score' && (
                                <>
                                    <div className='attributes-charts' id="attributesCharts">
                                        {renderSelectedAttributeDetails(selectedAttribute)}
                                        <Exapanders className='attributes-expander'>
                                            <Switch
                                                id="position"
                                                toggled={isLeague}
                                                onChange={handlePositionToggle}
                                                source='Filter'
                                                title="League"
                                                isByComparison={false}
                                                type='valueGraph'
                                            />
                                            <div style={{ height: '24px', border: '1px solid #DADADA' }}></div>
                                            {attributes.map(({ key, label, color }) => (
                                                <div className='attributes' key={key}>
                                                    <span className='attributes-marker' style={{ backgroundColor: color }}></span>
                                                    <LabelNumber className='position-text attribute-text'>{label}</LabelNumber>
                                                    <SecondaryButton
                                                        iconType='expander'
                                                        onClick={() => handleAttributeClick(key as keyof SelectedAttribute)}
                                                        isSelected={selectedAttribute[key as keyof SelectedAttribute]}
                                                    />
                                                </div>
                                            ))}
                                        </Exapanders>
                                        {(
                                            (hasNoAttributes && selectedAttribute.isPhysical) ||
                                            (hasbuildupNoAttributes && selectedAttribute.isBuildUpPlay) ||
                                            (hasfinalthirdNoAttributes && selectedAttribute.isFinalThird) ||
                                            (hasdefenceNoAttributes && selectedAttribute.isDefence)
                                        ) && (
                                                <>
                                                    <div className='no-attributes'></div>
                                                    <div className='no-attribute'>
                                                        <LabelText>Player’s<br /> score below<br />  threshold<br />
                                                            {/* <HelpOutlineIcon onClick={toggleLargeModal} className="clickable" /> */}
                                                        </LabelText>
                                                    </div>
                                                </>
                                            )
                                        }
                                        <svg ref={attributionSVG} id="attributeSVG" style={{borderRight :'2px solid #DADADA'}}/>
                                        {seasonAtrributesInfo && isFullView && renderAttributesInfoCard()}
                                    </div>
                                </>
                            )}
                            <div className='season' ref={CompetetionChartRef} style={{ position: 'relative'  , background:'white', borderTop:'1px solid #DADADA'}}>
                                <SvgStyled ref={CompetitionSVGRef} style={{borderRight :'2px solid #DADADA',direction:'rtl'}}/>
                                {/* {currentSeason && (
                                    <div className="sticky-season-label"
                                        style={{ position: 'absolute', top: '10px', left: '10px', background: '#fff', padding: '5px', border: '1px solid #000', zIndex: 1 }}>
                                        {currentSeason}
                                    </div>
                                )} */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* {displayCustomNotification && (
        <PWNotification
          message={customNotificationContent}
          setIsNotification={() => setDisplayCustomNotification(false)}
          isDisplayCloseIcon={true}
          className="player-filter-notification zoom-notification"
        />
      )} */}
        </>
    )
}

export default ValueGraphChartForSeasons